import { wasServerRendered } from '@/ssr/ssrData';

/**
 * Initial value for a hook that measures the viewport.
 *
 * There is no viewport on the server, so a server render has to assume one, and the first client
 * render of that document must assume the same thing or React tears the markup down as a
 * hydration mismatch. Both therefore start from `ssrDefault` (the narrow layout — the safe
 * assumption for a phone, and identical in content to the wide one), and an effect corrects it to
 * the real measurement on mount.
 *
 * A page that was not server-rendered measures immediately, exactly as before.
 */
export function initialViewportFlag(measure: () => boolean, ssrDefault = false): boolean {
    if (typeof window === 'undefined') return ssrDefault;
    if (wasServerRendered()) return ssrDefault;
    return measure();
}
